import React from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Tag } from 'antd';
import HelpCenter, { hasHelpCenterEntry } from '../../../containers/HelpCenter';
import AntTooltip from '../../global/AntTooltip';
import HorizontalScroll from '../../global/HorizontalScroll';
import { Analysis } from '../../../../types/analyses';
import { Analysis as AnalysisResources } from '../../../../types/resources';

type ItemAnalysisProps = {
  analyses: Analysis[];
  analysisResources: AnalysisResources;
  noCloseIcon?: boolean;
  hideAnalysis?: (id: number) => void;
};

const ItemAnalysis: React.FC<ItemAnalysisProps> = ({
  analyses,
  analysisResources,
  noCloseIcon,
  hideAnalysis,
}) => {
  const getColor = (alertType: number) => {
    switch (alertType) {
      case 1:
        return 'blue';
      case 2:
        return 'orange';
      case 3:
        return 'red';
      default:
        return '';
    }
  };

  const hideAnalyses = (typeId: number) => {
    if (hideAnalysis) hideAnalysis(typeId);
  };

  const showMessages = () =>
    analyses
      .map(analysis => {
        const analysisTypeResource = analysisResources.analysis_types.find(
          resource => resource.id === analysis.type_id
        );

        if (!analysisTypeResource || !analysisTypeResource.name) {
          return null;
        }

        const color = getColor(analysisTypeResource.alert_type_id);

        const tagElement = (
          <Tag
            key={analysis.type_id}
            color={color}
            closable={
              !noCloseIcon &&
              analysisTypeResource.xml_format_validation !== 1 &&
              analysisTypeResource.alert_type_id !== 3
            }
            onClose={() => hideAnalyses(analysis.type_id)}
          >
            <span>{analysisTypeResource.name}</span>
            {(hasHelpCenterEntry(analysisTypeResource.code) && (
              <HelpCenter id={analysisTypeResource.code} className={color} />
            )) ||
              (analysisTypeResource.description && (
                <span style={{ marginLeft: 5 }}>
                  <AntTooltip title={analysisTypeResource.description}>
                    <InfoCircleOutlined />
                  </AntTooltip>
                </span>
              ))}
          </Tag>
        );

        return tagElement;
      })
      .filter(Boolean);

  return (
    <div className="item-analysis-container">
      <HorizontalScroll>{showMessages()}</HorizontalScroll>
    </div>
  );
};

export default ItemAnalysis;
